export default __webpack_public_path__ + "static/media/itkes.6fb42e2f.png";